import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { SearchModel } from 'shared/search/search.model';
import { StatusModel } from 'shared/search/status.model';
import { PermissionsService } from 'shared/permissions/permissions.service';
import * as receiverActions from 'shared/receivers/receivers-actions';


@Component({
  moduleId: module.id,
  selector: 'receiver-actions',
  templateUrl: 'receiver-actions.component.html',
  styleUrls: ['receiver-actions.component.scss'],
})
export class ReceiverActionsComponent {
  receiverActions = receiverActions;
  @Input() selectedRows: Array<{}> = [];
  @Input() size: number = 0;
  @Input() allSelected: boolean = false;
  @Input() searchModel: SearchModel;
  @Input() statusModel: StatusModel;
  @Input() allowRemoveReceivers: boolean = false;
  @Input() allowApproveReceivers: boolean = false;

  @Output() actionSelected = new EventEmitter();

  constructor(
    protected permissionsService: PermissionsService
  ) { }

  get selectedRowsSize(): number|string {
    // if selected all items return total records length
    if (this.allSelected) {
      return `about ${this.size}`;
    }
    // if there is no sort by status return all selected rows length
    if (!this.statusModel) {
      return this.selectedRows.length;
    }
    // filter by status if status was choosen
    return _.filter( this.selectedRows, ['status',
      this.statusModel.id
    ]).length;
  }

  emitSelectedAction(action: any) {
    this.actionSelected.emit(action);
  }

  hasPermission(allow: Array<string>|string, requireAll: boolean= false): boolean {
    return this.permissionsService.hasPermission(allow, requireAll);
  }
}
